const info = {
  ZH: {
    //中文翻译
    languageZh: "中",
    languageEn: "英",
    dispatchCountryTips: "请选择始发地",
    destinationTips: "请选择目的地",
    day: "天",
    homeTitle: "123集运",
    freights: "国内运费",
    mianfei: "免",
    daocang: "到仓即发",
    kuai: "快",
    baoguo: "包裹减重",
    sheng: "省",
    ZH: "中国",
    dispatch: "发出地",
    mu: "目的地",
    check: "查询报价",
    liucehng: "集运流程",
    xiadan: "快捷下单",
    modiydan: "修改订单",
    shop: "购物",
    dengji: "包裹登记",
    xia: "下单",
    zhifu: "支付",
    fanli: "邀请返利",
    yaoqin: "邀请好友",
    jiluInvited: "邀请记录",
    fanxain: "返现记录",
    tixian: "立即提现",
    huodong: "最新活动",
    tekuai: "特快",
    pukuai: "普快",
    shihui: "经济实惠",
    home: "首页",
    jiyun: "集运",
    order: "我的订单",
    geren: "个人中心",
    yunshu: "运输方式",
    dizhi: "海外收件人地址",
    zenzhi: "增值服务",
    shenbao: "常用申报",
    pinming: "中文品名",
    epinming: "英文品名",
    num: "个数",
    danjia: "总价",
    invoice_currency: "币种",
    baoguohao: "包裹号",
    beizhu: "添加备注",
    lijixiadan: "立即下单",
    qinshuru: "请输入包裹号，多个请使用逗号,空格或换行分开",
    mudi: "选择目的地",
    qin: "请输入目的地名称",
    sousuo: "搜索",
    jiluHistory: "历史记录",
    remen: "热门目的地",
    deng: "登记包裹",
    store_code: "店铺代码",
    store_name: "店铺名称",
    order_number: "订单号",
    hs_code_name: "海关编码",
    h_weight: "重量",
    choosetian: "选填",
  },
  EN: {
    //英文翻译
    languageZh: "ZH",
    languageEn: "EN",
    dispatchCountryTips: "Please select the place of origin",
    destinationTips: "Please select the destination",
    day: "days",
    homeTitle: "centralized transportation",
    freights: "freight",
    mianfei: "free",
    daocang: "Instant",
    kuai: "fast",
    baoguo: "WeightLoss",
    sheng: "save",
    ZH: "China",
    dispatch: "dispatch",
    mu: "destination",
    check: "Query quotation",
    liucehng: "procedure",
    xiadan: "Quick Order",
    shop: "shopping",
    dengji: "registration",
    xia: "place order",
    zhifu: "pay",
    fanli: "Invitation rebate",
    yaoqin: "Invite friends",
    jiluInvited: "Invitation record",
    fanxain: "Cash back",
    tixian: "off hand",
    huodong: "Latest activities",
    tekuai: "express",
    pukuai: "fast",
    shihui: "Economics",
    home: "home",
    jiyun: "transportation",
    order: "My order",
    geren: "Personal",
    yunshu: "transport",
    dizhi: "Overseas recipient address",
    zenzhi: "Value added services",
    shenbao: "declare",
    pinming: "Product Name",
    epinming: "Product Name",
    num: "number",
    danjia: "Unit Price",
    invoice_currency: "Invoice Currency",
    baoguohao: "Package number",
    qinshuru:
      "Please enter the package number. Multiple packages shall be separated by commas, spaces or newlines",
    beizhu: "Add notes",
    lijixiadan: "Order now",
    mudi: "Select destination",
    qin: "Please enter destination name",
    sousuo: "search",
    jiluHistory: "Historical records",
    remen: "Popular",
    deng: "Register package",
    store_code: "ShopCode",
    store_name: "ShopName",
    order_number: "ordernumber",
    hs_code_name: "customscode",
    modiydan: "ChangeOrder",
    h_weight: "weight",
    choosetian: "optional",
  },
};
export default info;
